import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["Component"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import { debounce } from "../../utils/timed-functions";
import DescriptionsStateless from "./components/DescriptionsStateless";

/**
 * Switch for component container, passes down all the props,
 * and remaps Component to the one passed
 */
export function Description(_ref) {
  var Component = _ref.Component,
    commonProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Component, _extends({}, commonProps, {
    "data-t-id": "components-Descriptions"
  }));
}
Description.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.node.isRequired,
  // used as desktop link text, as content section title and as mobile accordion title
  children: PropTypes.node.isRequired,
  // content put inside AccordionDropdown content and desktop content section

  /** following props are passed down automatically by DescriptionsStateless/Descriptions */
  Component: PropTypes.func,
  // determines component to remap to
  TitleTag: PropTypes.string // tagName used for heading in content section of children
} : {};

/**
 * Stateful version, automatically manages desktop switches
 */
export var Descriptions = /*#__PURE__*/function (_React$Component) {
  _inherits(Descriptions, _React$Component);
  var _super = _createSuper(Descriptions);
  function Descriptions() {
    var _this;
    _classCallCheck(this, Descriptions);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      activeIndex: 0,
      isMobile: true
    });
    _defineProperty(_assertThisInitialized(_this), "checkDimensions", debounce(function () {
      _this.setState({
        isMobile: window.innerWidth < 768
      });
    }, 50));
    _defineProperty(_assertThisInitialized(_this), "handleIndexChange", function (activeIndex) {
      var onChangeIndex = _this.props.onChangeIndex;
      _this.setState({
        activeIndex: activeIndex
      }, function () {
        return onChangeIndex(activeIndex);
      });
    });
    return _this;
  }
  _createClass(Descriptions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkDimensions();
      window.addEventListener('resize', this.checkDimensions);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.checkDimensions);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        activeIndex = _this$state.activeIndex,
        isMobile = _this$state.isMobile;
      return /*#__PURE__*/React.createElement(DescriptionsStateless, _extends({}, this.props, {
        activeIndex: activeIndex,
        isMobile: isMobile,
        onChangeIndex: this.handleIndexChange
      }));
    }
  }]);
  return Descriptions;
}(React.Component);
Descriptions.defaultProps = {
  titleTag: 'div',
  onChangeIndex: function onChangeIndex() {}
};
Descriptions.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  // inheritedProps
  titleTag: PropTypes.string,
  // inheritedProps
  additional: PropTypes.element,
  // inheritedProps
  onChangeIndex: PropTypes.func
} : {};